export class ByteConverter {
	static BYTES_IN_KILOBYTE = 1024
	static KILOBYTES_IN_MEGABYTE = 1024
	static BYTES_IN_MEGABYTE = this.BYTES_IN_KILOBYTE * this.KILOBYTES_IN_MEGABYTE

	static bytesToMegabytesFormated(bytesSize: number): string {
		return `${this.bytesToMegabytes(bytesSize)} MB`
	}

	static bytesToMegabytes(bytesSize: number): number {
		const sizeInMB = (bytesSize / this.BYTES_IN_MEGABYTE).toFixed(2)
		return Number(sizeInMB)
	}
}
